import { AvailablePlansRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/billing/available-plans/journeys')({
  component: AvailablePlansRoute,
});
